import { useRentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

const useConvertSingleFamilyToRoomForRent = () =>
  useRentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent({
    meta: {
      context: {
        api: 'rentalManager',
        details: 'useRentalManagerUserPropertyConvertWebApiHandler_singleFamilyToRoomForRent',
      },
      invalidates: ['users-properties-convert-singleFamilyToRoomForRent'],
    },
  });

export { useConvertSingleFamilyToRoomForRent };
